// import React, { useEffect, useState } from "react";
// import { Scrollbars } from "react-custom-scrollbars-2";
// import { Card, CardBody } from "@windmill/react-ui";

// import Title from "components/form/Title";
// import LabelArea from "components/form/LabelArea";
// import Error from "components/form/Error";
// import DrawerButton from "components/form/DrawerButton";
// import InputAreaPrice from "components/form/InputAreaPrice";
// import InputName from "components/form/InputName";
// import InputAreaDate from "components/form/InputAreaDate";
// import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";

// import useOverrideMarginSubmit from "hooks/useOverrideMarginSubmit";

// import VehicleCategoryServices from "services/VehicleCategoryServices";
// import DynamicOverrideMarginInput from "components/form/DynamicOverrideMarginInput";

// const OverrideMarginDrawer = ({ id }) => {
//     const {
//         register,
//         trigger,
//         handleSubmit,
//         onSubmit,
//         loading,
//         errors,
//         marginData,
//         startDate,
//         endDate,
//         setEndDate,
//         handleStartDateChange,
//         selectedCity,
//         setSelectedCity,
//         setValue,
//     } = useOverrideMarginSubmit(id);

//     const [allVehicleCategory, setVehicleCategory] = useState([]);

//     // Dynamic Vehicle Rows
//     const [vehicleRows, setVehicleRows] = useState([
//         {
//             id: Date.now(),
//             vehicleId: "",
//             value: "",
//         },
//     ]);

//     // -----------------------------
//     // Load Vehicle Categories
//     // -----------------------------
//     useEffect(() => {
//         async function fetchVehicleCategory() {
//             try {
//                 const response =
//                     await VehicleCategoryServices.getAllVehicleCategory();

//                 setVehicleCategory(response.data || []);
//             } catch (error) {
//                 console.error(error);
//             }
//         }

//         fetchVehicleCategory();
//     }, []);

//     // -----------------------------
//     // Add Row
//     // -----------------------------
//     const addVehicleRow = () => {
//         if (
//             vehicleRows.length >=
//             allVehicleCategory.length
//         )
//             return;

//         setVehicleRows((prev) => [
//             ...prev,
//             {
//                 id: Date.now() + Math.random(),
//                 vehicleId: "",
//                 value: "",
//             },
//         ]);
//     };

//     // -----------------------------
//     // Remove Row
//     // -----------------------------
//     const removeVehicleRow = (rowId) => {
//         setVehicleRows((prev) =>
//             prev.filter((row) => row.id !== rowId)
//         );
//     };

//     // -----------------------------
//     // Vehicle Change
//     // -----------------------------
//     const handleVehicleChange = (
//         index,
//         vehicleId
//     ) => {
//         setVehicleRows((prev) => {
//             const updated = [...prev];

//             updated[index].vehicleId = vehicleId;

//             return updated;
//         });

//         setValue(`margin.${vehicleId}`, "");
//     };

//     // -----------------------------
//     // Margin Change
//     // -----------------------------
//     const handleMarginChange = (
//         index,
//         value
//     ) => {
//         value = value.replace(/\D/g, "");

//         if (value !== "") {
//             value = Number(value);

//             if (value > 100) value = 100;

//             if (
//                 value < 15 &&
//                 value.toString().length >= 2
//             ) {
//                 value = 15;
//             }
//         }

//         setVehicleRows((prev) => {
//             const updated = [...prev];

//             updated[index].value = value;

//             return updated;
//         });

//         const vehicleId =
//             vehicleRows[index]?.vehicleId;

//         if (vehicleId) {
//             setValue(`margin.${vehicleId}`, value);
//         }
//     };

//     // -----------------------------
//     // Edit Mode
//     // -----------------------------
//     useEffect(() => {
//         if (
//             id &&
//             marginData?.margin_details
//         ) {
//             const rows = Object.entries(
//                 marginData.margin_details
//             ).map(([vehicleId, vehicle]) => ({
//                 id: Date.now() + Math.random(),
//                 vehicleId,
//                 value: vehicle.margin,
//             }));

//             if (rows.length) {
//                 setVehicleRows(rows);

//                 rows.forEach((row) => {
//                     setValue(
//                         `margin.${row.vehicleId}`,
//                         row.value
//                     );
//                 });
//             }
//         }

//         if (!id) {
//             setVehicleRows([
//                 {
//                     id: Date.now(),
//                     vehicleId: "",
//                     value: "",
//                 },
//             ]);
//         }
//     }, [id, marginData, setValue]);

//     return (
//         <>
//             <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
//                 <Title
//                     register={register}
//                     title={
//                         id
//                             ? "Edit Override Margin"
//                             : "Add Override Margin"
//                     }
//                 />
//             </div>

//             <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
//                 <Card
//                     className="flex-grow w-full"
//                     style={{ overflow: "visible" }}
//                 >
//                     <CardBody>
//                         <form
//                             onSubmit={handleSubmit(onSubmit)}
//                         >
//                             <div className="px-2 pb-20">

//                                 {/* -----------------------------
//                 City
//             ----------------------------- */}

//                                 <div className="grid grid-cols-12 gap-5 mb-8">

//                                     <div className="col-span-12">

//                                         <LabelArea
//                                             required
//                                             label="City"
//                                         />

//                                         {id ? (
//                                             <>
//                                                 <InputName
//                                                     register={register}
//                                                     name="city_name"
//                                                     disabled
//                                                 />

//                                                 <Error
//                                                     errorName={
//                                                         errors.city_name
//                                                     }
//                                                 />
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <SelectSingleCityOnly
//                                                     register={register}
//                                                     name="id_city"
//                                                     placeholder="--Choose City--"
//                                                     selectedCity={
//                                                         selectedCity
//                                                     }
//                                                     handleCityChange={
//                                                         setSelectedCity
//                                                     }
//                                                 />

//                                                 <Error
//                                                     errorName={
//                                                         errors.id_city
//                                                     }
//                                                 />
//                                             </>
//                                         )}

//                                     </div>

//                                 </div>

//                                 {/* -----------------------------
//                 Dates
//             ----------------------------- */}

//                                 <div className="grid grid-cols-12 gap-6 mb-6">

//                                     <div className="col-span-12">
//                                         <LabelArea label="City" />

//                                         {id ? (
//                                             <>
//                                                 <InputName
//                                                     register={register}
//                                                     name="city_name"
//                                                     disabled
//                                                 />
//                                                 <Error errorName={errors.city_name} />
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <SelectSingleCityOnly
//                                                     register={register}
//                                                     name="id_city"
//                                                     selectedCity={selectedCity}
//                                                     handleCityChange={setSelectedCity}
//                                                 />
//                                                 <Error errorName={errors.id_city} />
//                                             </>
//                                         )}
//                                     </div>

//                                     <div className="col-span-6">
//                                         <LabelArea label="Start Date" />

//                                         <InputAreaDate
//                                             trigger={trigger}
//                                             register={register}
//                                             name="start_date"
//                                             value={startDate}
//                                             type="date"
//                                             onChange={handleStartDateChange}
//                                             min={new Date()}
//                                         />

//                                         <Error errorName={errors.start_date} />
//                                     </div>

//                                     <div className="col-span-6">
//                                         <LabelArea label="End Date" />

//                                         <InputAreaDate
//                                             trigger={trigger}
//                                             register={register}
//                                             name="end_date"
//                                             value={endDate}
//                                             type="date"
//                                             onChange={(event) => setEndDate(event)}
//                                             min={
//                                                 startDate
//                                                     ? startDate < new Date()
//                                                         ? new Date()
//                                                         : startDate
//                                                     : new Date()
//                                             }
//                                         />

//                                         <Error errorName={errors.end_date} />
//                                     </div>

//                                 </div>

//                                 <DynamicOverrideMarginInput
//                                     register={register}
//                                     trigger={trigger}
//                                     errors={errors}

//                                     dataInput={dataInput}
//                                     setDataInput={setDataInput}

//                                     selectedOptions={selectedOptions}
//                                     setSelectedOptions={setSelectedOptions}

//                                     handleVehicleCategoryChange={handleVehicleCategoryChange}
//                                     handleChange={handleMarginChange}
//                                 />

//                                 {/* -----------------------------
//                 Vehicle Margin Section
//             ----------------------------- */}

//                                 <div className="border rounded-xl p-5 bg-gray-50">

//                                     <div className="flex items-center justify-between mb-5">

//                                         <div>

//                                             <h3 className="text-base font-semibold text-gray-800">
//                                                 Vehicle Margin
//                                             </h3>

//                                             <p className="text-xs text-gray-500 mt-1">
//                                                 Add only the required
//                                                 vehicle margins.
//                                             </p>

//                                         </div>

//                                     </div>

//                                     {/* Part 3 starts here */}

//                                     {vehicleRows.map((row, index) => (
//                                         <div
//                                             key={row.id}
//                                             className="grid grid-cols-12 gap-4 mb-5 items-end border-b border-gray-200 pb-5 last:border-b-0"
//                                         >
//                                             {/* Vehicle Type */}
//                                             <div className="col-span-5">
//                                                 <LabelArea
//                                                     required
//                                                     label="Vehicle Type"
//                                                 />

//                                                 <select
//                                                     className="
//           w-full
//           h-10
//           rounded-md
//           border
//           border-gray-300
//           bg-white
//           px-3
//           text-sm
//           focus:border-green-500
//           focus:outline-none
//         "
//                                                     value={row.vehicleId}
//                                                     onChange={(e) =>
//                                                         handleVehicleChange(
//                                                             index,
//                                                             e.target.value
//                                                         )
//                                                     }
//                                                 >
//                                                     <option value="">
//                                                         -- Select Vehicle --
//                                                     </option>

//                                                     {allVehicleCategory
//                                                         .filter(
//                                                             (vehicle) =>
//                                                                 !vehicleRows.some(
//                                                                     (r, i) =>
//                                                                         i !== index &&
//                                                                         r.vehicleId ===
//                                                                         String(vehicle.id)
//                                                                 )
//                                                         )
//                                                         .map((vehicle) => (
//                                                             <option
//                                                                 key={vehicle.id}
//                                                                 value={vehicle.id}
//                                                             >
//                                                                 {vehicle.vehicle_type_name}
//                                                             </option>
//                                                         ))}
//                                                 </select>
//                                             </div>

//                                             {/* Margin */}
//                                             <div className="col-span-5">
//                                                 <LabelArea
//                                                     required
//                                                     label="Margin (%)"
//                                                 />

//                                                 <InputAreaPrice
//                                                     trigger={trigger}
//                                                     register={register}
//                                                     name={`margin.${row.vehicleId}`}
//                                                     value={row.value}
//                                                     type="text"
//                                                     maxLength={3}
//                                                     placeholder="Enter Margin %"
//                                                     onChangeFunction={(e) =>
//                                                         handleMarginChange(
//                                                             index,
//                                                             e.target.value
//                                                         )
//                                                     }
//                                                 />

//                                                 <Error
//                                                     errorName={
//                                                         errors?.margin?.[
//                                                         row.vehicleId
//                                                         ]
//                                                     }
//                                                 />
//                                             </div>

//                                             {/* Remove Button */}
//                                             <div className="col-span-2 flex items-center gap-2">

//                                                 {vehicleRows.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() =>
//                                                             removeVehicleRow(row.id)
//                                                         }
//                                                         className="
//             h-10
//             w-10
//             rounded-md
//             border
//             border-red-300
//             text-red-500
//             hover:bg-red-50
//             hover:border-red-500
//             transition
//           "
//                                                     >
//                                                         ✕
//                                                     </button>
//                                                 )}

//                                             </div>
//                                         </div>
//                                     ))}

//                                     {/* Add Vehicle Button */}

//                                     <div className="flex justify-end">

//                                         <button
//                                             type="button"
//                                             onClick={addVehicleRow}
//                                             disabled={
//                                                 vehicleRows.length >=
//                                                 allVehicleCategory.length
//                                             }
//                                             className="
//       flex
//       items-center
//       gap-2
//       rounded-lg
//       bg-green-600
//       px-4
//       py-2
//       text-sm
//       font-semibold
//       text-white
//       hover:bg-green-700
//       disabled:cursor-not-allowed
//       disabled:bg-gray-300
//     "
//                                         >
//                                             <span className="text-lg">+</span>

//                                             Add Vehicle
//                                         </button>

//                                     </div>
//                                 </div>

//                             </div>

//                             <DrawerButton
//                                 isSubmitting={loading}
//                                 id={id}
//                                 title={
//                                     id
//                                         ? "Update"
//                                         : "Save"
//                                 }
//                             />

//                         </form>

//                     </CardBody>

//                 </Card>

//             </Scrollbars>

//         </>
//     )
// };

// export default OverrideMarginDrawer;







import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import InputName from "components/form/InputName";
import InputAreaDate from "components/form/InputAreaDate";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import DynamicOverrideMarginInput from "components/form/DynamicOverrideMarginInput";

import useOverrideMarginSubmit from "hooks/useOverrideMarginSubmit";

const OverrideMarginDrawer = ({ id }) => {
  const {
    register,
    trigger,
    handleSubmit,
    onSubmit,
    loading,
    errors,

    marginData,

    startDate,
    endDate,
    setEndDate,
    handleStartDateChange,

    selectedCity,
    setSelectedCity,

    setValue,
  } = useOverrideMarginSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title
          title={
            id
              ? "Edit Periodic Hike Margin"
              : "Add Periodic Hike Margin"
          }
        />
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card
          className="flex-grow w-full"
          style={{ overflow: "visible" }}
        >
          <CardBody>

            <form onSubmit={handleSubmit(onSubmit)}>

              <div className="px-6 pt-2 pb-40">

                {/* City */}

                <div className="grid grid-cols-12 gap-6 mb-6">

                  <div className="col-span-12">

                    <LabelArea
                      required
                      label="City"
                    />

                    {id ? (
                      <>
                        <InputName
                          register={register}
                          name="city_name"
                          disabled
                        />

                        <Error
                          errorName={errors.city_name}
                        />
                      </>
                    ) : (
                      <>
                        <SelectSingleCityOnly
                          register={register}
                          name="id_city"
                          placeholder="--Choose City--"
                          selectedCity={selectedCity}
                          handleCityChange={setSelectedCity}
                        />

                        <Error
                          errorName={errors.city_name}
                        />
                      </>
                    )}

                  </div>

                </div>

                {/* Dates */}

                <div className="grid grid-cols-12 gap-6 mb-8">

                  <div className="col-span-6">

                    <LabelArea
                      label="Start Date"
                    />

                    <InputAreaDate
                      trigger={trigger}
                      register={register}
                      name="start_date"
                      type="date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      min={new Date()}
                    />

                    <Error
                      errorName={errors.start_date}
                    />

                  </div>

                  <div className="col-span-6">

                    <LabelArea
                      label="End Date"
                    />

                    <InputAreaDate
                      trigger={trigger}
                      register={register}
                      name="end_date"
                      type="date"
                      value={endDate}
                      onChange={(date) =>
                        setEndDate(date)
                      }
                      min={
                        startDate
                          ? startDate < new Date()
                            ? new Date()
                            : startDate
                          : new Date()
                      }
                    />

                    <Error
                      errorName={errors.end_date}
                    />

                  </div>

                </div>

                <DynamicOverrideMarginInput
                  register={register}
                  trigger={trigger}
                  errors={errors}
                  setValue={setValue}
                  marginData={marginData}
                  id={id}
                />

              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={
                  id
                    ? "Update"
                    : "Save"
                }
              />

            </form>

          </CardBody>

        </Card>

      </Scrollbars>

    </>
  );
};

export default OverrideMarginDrawer;